import { formattedRouteString } from "./formatted-route-string.model";
import { Point } from "./point.model";

export class AccessPlan {
    ingress: formattedRouteString[];
    egress: formattedRouteString[];
    ingressPath: string;
    egressPath: string;
    separator: string;

    constructor(
        routes: formattedRouteString[],
        isIngress: boolean,
        public points: Point[] = []) {
        if (isIngress) {
            this.ingress = routes;
            this.egress = routes.reverse();

        } else {
            this.egress = routes;
            this.ingress = routes.reverse();
        }

        if (routes.length > 0) {
            this.ingressPath = this.ingress.toString();
            this.egressPath = this.egress.toString();
            this.separator = routes[0].separator;
        }
    }
}
